import Api from "./Api";

const abortKey = "FiBuBuchungApi";
const endpoint = "/fibu/spendenquittung";
export default {
    abort() {
        Api.abort(abortKey);
    },
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint, usedParams, true, false, abortKey);
    },
    getSingle(id, spId) {
        return Api.fetchData(endpoint + '/' + id + '/nachdruck/' + spId);
    }
};
